import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '*',
		name: 'Not Found',
		component: () => import(/* webpackChunkName: "not-found" */'../views/NotFound.vue')
	},
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/patients',
		name: 'Patients',
		component: () => import(/* webpackChunkName: "patients" */'../views/Patients.vue')
	},
	{
		path: '/healthcare-professionals',
		name: 'Healthcare Professionals',
		component: () => import(/* webpackChunkName: "professionals" */'../views/Professionals.vue')
	},
	{
		path: '/about',
		name: 'About',
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				offset: { x: 0, y: 118 }
			}
		}
		else {
			return { x: 0, y: 0 }
		}
	}
})

export default router